// Documents Ready

document.addEventListener("DOMContentLoaded", function () {
  // mobile menu button

  $(".btn--link.site-header__icon.site-header__menu.js-mobile-nav-toggle").on("click", function () {
    if ($("body").hasClass("is--disable")) {
      $("body").removeClass("is--disable");
    } else {
      $("body").addClass("is--disable");
    }
  });
  // mobile menu button - copy

  $(".mobile-menu-button-clone").on("click", function () {
    if ($(this).hasClass("is--close")) {
      $("body").removeClass("is--disable");
      $(this).removeClass("is--close");
      $(".mobile-nav-wrapper.medium-up--hide").removeClass("js-menu--is-open");
    } else {
      $("body").addClass("is--disable");
      $(this).addClass("is--close");
      $(".mobile-nav-wrapper.medium-up--hide").addClass("js-menu--is-open");
    }
  });

  $(".btn--link.site-header__icon.site-header__menu.js-mobile-nav-toggle").on("click", function () {
    if ($("body").hasClass("is--disable")) {
      $("body").removeClass("is--disable");
    } else {
      $("body").addClass("is--disable");
    }
  });

  // scroll header

  // let headNav = $(".template-index .site-header");
  // $(window).on("load scroll", function () {
  //   if ($(this).scrollTop() > 120 && headNav.hasClass("is--active") == false) {
  //     headNav.addClass("is--active");
  //   } else if ($(this).scrollTop() < 120 && headNav.hasClass("is--active") == true) {
  //     headNav.removeClass("is--active");
  //   }
  // });


  // pagetop button
  var scrollDisplayElm = document.querySelectorAll(
    '[data-action="scrollToTop"]'
  );
  window.addEventListener('scroll',function(){
    var scroll_position = window.pageYOffset;
    if (scroll_position > 200) {
      scrollDisplayElm[0].classList.remove("hide");
      scrollDisplayElm[0].classList.add("show");
    } else if (scrollDisplayElm[0].classList.contains("show")) {
      scrollDisplayElm[0].classList.remove("show");
      scrollDisplayElm[0].classList.add("hide");
    }
  })



  // FAQ Toggle

  const TGFQ = document.querySelectorAll(".page-faq__faq-body .question");
  for (let i = 0; i < TGFQ.length; i++) {
    TGFQ[i].addEventListener("click", function () {
      let $next = this.nextElementSibling;
      let h = $next.firstElementChild.clientHeight;

      if (this.classList.contains("is--active")) {
        this.classList.remove("is--active");
        $next.style.height = "0px";
        $next.classList.remove("is--active");
      } else {
        this.classList.add("is--active");
        $next.style.height = h + "px";
        $next.classList.add("is--active");
      }
    });
  }

  // FAQ Toggle - header （for mobile）
  const TGFQH = document.querySelectorAll(".chapter-list-group > .chapter-list-title");

  for (let i = 0; i < TGFQH.length; i++) {
    TGFQH[i].addEventListener("click", function () {
      let $next = this.nextElementSibling;
      let h = $next.firstElementChild.clientHeight;

      if (this.classList.contains("is--active")) {
        this.classList.remove("is--active");
        $next.style.height = "0px";
      } else {
        this.classList.add("is--active");
        $next.style.height = h + "px";
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth >= 751) {
        $(TGFQH).removeClass("is--active");

        $(TGFQH).next().css("height", "auto");
      }
    });
  }
});

// submenu  at Mobile View 2022 7 22

$(".product-category__menu ul.main-category__menu li.main-category__item").on("click", function () {
  const Cld = document.querySelectorAll(".product-category__menu ul.main-category__menu li.main-category__item");

  if ($(this).hasClass("is--active")) {
    $(this).removeClass("is--active");
  } else {
    $(Cld).removeClass("is--active");
    $(this).addClass("is--active");
  }
});


// sort_by
document.addEventListener("DOMContentLoaded", function () {
  var select = document.getElementById("SortBy");
  var selected_param = getParam('sort_by');

  if (select === null) return;
  for (var i = 0; i < select.options.length; i++) {
    if (select.options[i].value == selected_param) {
      select.options[i].selected = true;
    }
  }
});

//URLパラメーター取得
function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



// ON Load
window.addEventListener("load", function () {
  /* First Fade in */

  // const TI = document.getElementsByClassName('template-index');
  // TI.classList.add('is--active');
  $(".template-index").addClass("is--active");
  $(".template-page-onlineshop-top").addClass("is--active");
  $(".template-collection-mentalphysicseries").addClass("is--active");
});

//Swiper int

const swiper = new Swiper("#topECMarquee", {
  slidesPerView: 1.5,
  loop: true,
  slidesPerView: "auto", //必須
  centeredSlides: true, //1枚目のスライド中央配置
  spaceBetween: 20,
  speed: 4000,
  autoplay: {
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    reverseDirection: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const swiperTopCorp = new Swiper("#topCorpMarquee", {
  slidesPerView: 1,
  loop: true,
  slidesPerView: "auto",
  effect: "fade",
  speed: 3000,

  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    reverseDirection: false,
  },
});

/* quick-add-hidden  =============== */
const quick_add_hidden = document.getElementsByClassName("quick-add-hidden");

if (quick_add_hidden !== null) {
    // let quick_add_hidden_button_e = document.createElement("button");
    // quick_add_hidden_button_e.setAttribute("class", "button-readmore");
  let quick_add_hidden_button_e = document.getElementsByClassName("button-readmore");
  for (let i = 0; i < quick_add_hidden.length; i++) {
      // quick_add_hidden[i].after(quick_add_hidden_button_e);
      quick_add_hidden_button_e[0].addEventListener("click", (e) => {
        quick_add_hidden_button_e[0].previousElementSibling.classList.add("is--active");
      });
    }
  }
